module.exports = __webpack_public_path__ + "img/noPeriodicChart.09d60c4f.svg";